import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AudioProvider } from "@/context/AudioProvider";
import SmoothScroll from "@/components/SmoothScroll";
import Landing from "@/pages/Landing";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import Pay from "@/pages/Pay";
import PaymentSuccess from "@/pages/PaymentSuccess";

function App() {
  return (
    <AudioProvider>
      <Toaster position="bottom-right" toastOptions={{ style: { fontFamily: "JetBrains Mono", borderRadius: 0 } }} />
      <BrowserRouter>
        <Routes>
          <Route
            path="/"
            element={
              <SmoothScroll>
                <Landing />
              </SmoothScroll>
            }
          />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/pay" element={<Pay />} />
          <Route path="/payment-success" element={<PaymentSuccess />} />
        </Routes>
      </BrowserRouter>
    </AudioProvider>
  );
}

export default App;
